import { useState } from 'react';
import { YoutubeVideoModal } from './YoutubeVideoModal';
import { parseYoutubeUrl, youtubeThumbnailUrl } from './youtube-url';
import './YoutubeVideo.scss';

type YoutubeVideoPreviewProps = {
  url?: string | null;
  title: string;
};

export function YoutubeVideoPreview({ url, title }: YoutubeVideoPreviewProps) {
  const video = parseYoutubeUrl(url);
  const [open, setOpen] = useState(false);
  const [thumbFailed, setThumbFailed] = useState(false);
  const trimmed = url?.trim() ?? '';

  return (
    <div className="youtube-video-preview">
      <span className="youtube-video-preview__label">{title}</span>
      {!trimmed ? <p className="youtube-video-preview__empty">—</p> : null}
      {trimmed && !video ? (
        <p className="youtube-video-preview__plain">{trimmed}</p>
      ) : null}
      {video ? (
        <>
          <button
            type="button"
            className="youtube-video-preview__open"
            aria-label={title}
            onClick={() => setOpen(true)}
          >
            <span className="youtube-video-preview__stage">
              {thumbFailed ? (
                <span className="youtube-video-preview__fallback" />
              ) : (
                <img
                  src={youtubeThumbnailUrl(video.videoId)}
                  alt=""
                  onError={() => setThumbFailed(true)}
                />
              )}
              <span className="youtube-video-preview__play" aria-hidden>
                ▶
              </span>
            </span>
          </button>
          <YoutubeVideoModal
            videoId={video.videoId}
            open={open}
            onClose={() => setOpen(false)}
            title={title}
          />
        </>
      ) : null}
    </div>
  );
}
